
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/baseUI/liveChat/copyButton/copyButton.scss.css.virtualfile';
        module.exports = {"copyButton":"_copyButton_1gwvw_1"};